import { useState } from 'react';
import { useHistory } from 'react-router';
import { Box, makeStyles, TextField } from '@material-ui/core';

import MainModal from 'src/components/ui/MainModal';
import MainInfo from './MainInfo';
import LoadWithSpinner from 'src/components/ui/Loading/LoadWithSpinner';

import { PathBuilder } from 'src/routing';
import { Lifecycle, SimpleRequestStatus } from 'src/state/request';

const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: '1rem',
    fontWeight: 500,
    marginBottom: theme.spacing(2),
  },
  label: {
    color: theme.palette.text.secondary,
    fontSize: 12,
    marginBottom: theme.spacing(0.5),
    textTransform: 'uppercase',
  },
  value: {
    fontSize: 16,
  },
  noteField: {
    '& .MuiOutlinedInput-inputMultiline': {
      padding: theme.spacing(1.5),
    },
  },
}));

interface UpdateModalProps {
  alarmId: string;
  alarmTagId: string;
  handleSubmit: (siteId: number, alarmTagId: string, alarmId: string, noteText: string) => void;
  label: string;
  noteRequired?: boolean;
  primaryButtonLabel: string;
  requestStatus: SimpleRequestStatus;
  siteId: number;
  status: string;
  title: string;
  triggeredDate: string;
}

const UpdateModal = ({
  alarmId,
  alarmTagId,
  handleSubmit,
  label,
  noteRequired = false,
  primaryButtonLabel,
  requestStatus,
  siteId,
  status,
  title,
  triggeredDate,
}: UpdateModalProps) => {
  const classes = useStyles();
  const history = useHistory();
  const [noteText, setNoteText] = useState('');

  const onClose = () => history.push(PathBuilder.ALARM_DETAILS(siteId, alarmId, alarmTagId));

  const onSubmit = () => {
    handleSubmit(siteId, alarmTagId, alarmId, noteText);
  };

  return (
    <MainModal
      buttonTestId="alarm-action-submit"
      disabledPrimaryButton={(noteRequired && !noteText) || requestStatus === Lifecycle.LOADING}
      disabledSecondaryButton={requestStatus === Lifecycle.LOADING}
      height={347}
      isOpen
      isSmall
      onClose={onClose}
      onPrimaryAction={onSubmit}
      onSecondaryAction={onClose}
      primaryButtonLabel={primaryButtonLabel}
      secondaryButtonLabel="Cancel"
      testId="alarm-ack-form"
      title={title}
      width={512}
      headerDivider={false}
    >
      {requestStatus === Lifecycle.LOADING && <LoadWithSpinner />}
      {!requestStatus && (
        <Box>
          <MainInfo status={status} triggeredDate={triggeredDate} label={label} />
          <Box>
            <TextField
              className={classes.noteField}
              fullWidth
              label="Note"
              multiline
              onChange={(e) => setNoteText(e.target.value)}
              value={noteText}
              variant="outlined"
              data-testid="ack-note-textbox"
            />
          </Box>
        </Box>
      )}
    </MainModal>
  );
};

export default UpdateModal;
